function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
/** Allows clients to register listeners which are called using trigger. */ export var EventChannel = /*#__PURE__*/ function() {
    "use strict";
    function EventChannel() {
        _classCallCheck(this, EventChannel);
        this.listeners = [];
    }
    var _proto = EventChannel.prototype;
    _proto.subscribe = function subscribe(callback) {
        this.listeners.push(callback);
        return this.unsubscribe.bind(this, callback);
    };
    _proto.trigger = function trigger(data) {
        this.listeners.forEach(function(listener) {
            return listener(data);
        });
    };
    _proto.teardown = function teardown() {
        this.listeners = [];
    };
    _proto.unsubscribe = function unsubscribe(callback) {
        this.listeners = this.listeners.filter(function(listener) {
            return listener !== callback;
        });
    };
    return EventChannel;
}();
